import React from "react";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import ScorecardFilters from "../App/ScorecardFilters";
import RetailerScorecardDetails from "../App/RetailerScorecardDetails";
import RetailerScorecardDetailsCharts from "../App/RetailerScorecardDetailsCharts";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import TabFilter from "../App/TabFilter";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";

import LineChart from "../Charts/LineChart";
import DownloadPopup from "../App/DownloadPopup";
import { SortTheList } from "../Shared/Utility";
type Props = {
  ScreenID: number;
};
function NSAScorecard(props: Props) {
  const [sectionScorecardFactorKeysData, setSectionScorecardFactorKeysData] =
    useState<any>([]);
  const [showLoadinganimation, setShowLoadinganimation] = useState(false);
  const [lineChartPopup, setLineChartPopup] = useState(false);
  const [trendingGraphFactorData, setTrendingGraphFactorData] = useState([]);
  const [trendingGraphFactorObject, setTrendingGraphFactorObject] = useState({
    dealerid: 0,
    ficilityid: 0,
    name: "",
    year: 0,
    brand: 0,
    keyid: 0,
    factortype: 0,
    typeid: 0,
    quaternuber: 0,
    screenid: 0,
  });
  const [checkedPoints, setChecked] = React.useState(true);

  const handleChange = () => {
    setChecked(!checkedPoints);

  };
  const [filters, setFilters] = useState(["CurrentScore", "D"]);
  const [thisGridListData, setThisGridListData] = useState([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;

  let toggledatarangeArray = [
    { Name: "Absolute", ID: 1 },
    { Name: "Comparative", ID: 2 },
  ];
  let toggledataArray = [
    { Name: "Retailer", ID: 1 },
    { Name: "Importer", ID: 2 },
  ];
  let typeofreportdataArray = [
    { Name: "Month", ID: 1 },
    { Name: "YTD", ID: 2 },
  ];

  const [selectedId, setSelectedId] = useState({
    Dealers: 0,
    Facilities: 0,
    Years: 0,
    Months: 0,
    Brand: 0,
  });

  const [factorKeysObject, setFactorKeysObject] = useState({
    toggledata: 1,
    Step: 1,
    Typeofreportdata: 1,
    Toggledatarange: 1,
  });

  ///--States for columnFilter components---///
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [filterLists, setFilterLists] = useState([]);
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = sectionScorecardFactorKeysData as any;
    l_data[1] = FilterData;
    setSectionScorecardFactorKeysData(l_data);
    thisGridListDataRef.current = FilterData;
    HandleSortAndLoadData();
  }

  //--States for columnFilter components---///

  function ScorecardFiltersCallBack(p_selectedId: any) {
    selectedId.Dealers = p_selectedId.Dealers;
    selectedId.Facilities = p_selectedId.Facilities;
    selectedId.Years = p_selectedId.Years;
    selectedId.Months = p_selectedId.Months;
    selectedId.Brand = p_selectedId.Brand;
    setSelectedId(selectedId);
    getSectionScorecardFactorKeysData();
  }

  useEffect(() => {
    getSectionScorecardFactorKeysData();
  }, [factorKeysObject, props.ScreenID]);

  function getSectionScorecardFactorKeysData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = props.ScreenID;
    object.dealerid = selectedId.Dealers;
    object.facilityid = selectedId.Facilities;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    object.brandid = selectedId.Brand;
    object.toggledata = factorKeysObject.toggledata;
    object.step = factorKeysObject.Step;
    object.typeofreportdata = factorKeysObject.Typeofreportdata;
    object.toggledatarange = factorKeysObject.Toggledatarange;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetSectionScorecardFactorKeysData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;

          if (factorKeysObject.Typeofreportdata == 1) {
            setFilters(["CurrentScore", "D"]);
          } else {
            setFilters(["YTDScore", "D"]);
          }

          let rank = 0;
          for (var k = 0; k < l_response[1].length; k++) {
            if (l_response[1][k].DealerName === "MENA Average") {
              l_response[1][k].Rank = 0;
            } else {
              rank += 1;
              l_response[1][k].Rank = rank;
            }
          }

          setRefreshFilters(!setRefreshFilters);
          setSectionScorecardFactorKeysData(l_response);

          setThisGridListData(l_response[1]);
          thisGridListDataRef.current = l_response[1];
          HandleSortAndLoadData();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function handleTabFilterCallback(TabFilterData: any) {
    let ID = TabFilterData.ID;
    let Type = TabFilterData.Type;
    if (Type === 1) {
      factorKeysObject.Toggledatarange = ID;
      setFactorKeysObject((prevState: any) => ({
        ...prevState,
        Toggledatarange: ID,
      }));
    } else if (Type === 2) {
      factorKeysObject.toggledata = ID;
      setFactorKeysObject((prevState: any) => ({
        ...prevState,
        toggledata: ID,
      }));
    } else if (Type === 3) {
      factorKeysObject.Typeofreportdata = ID;
      setFactorKeysObject((prevState: any) => ({
        ...prevState,
        Typeofreportdata: ID,
      }));
    }
  }

  function bindTrendingGraphFactor(
    dealerid: any,
    ficilityid: any,
    name: any,
    year: any,
    brand: any,
    keyid: any,
    factortype: any,
    typeid: any,
    quaternuber: any,
    screenid: any
  ) {
    if (name.indexOf("MENA Average") < 0) {
      getTrendingGraphData(
        dealerid,
        ficilityid,
        name,
        year,
        brand,
        keyid,
        factortype,
        typeid,
        quaternuber,
        screenid
      );
    }
  }

  function getTrendingGraphData(
    dealerid: any,
    ficilityid: any,
    name: any,
    year: any,
    brand: any,
    keyid: any,
    factortype: any,
    typeid: any,
    quaternuber: any,
    screenid: any
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = screenid;
    object.network = 1;
    object.sales = 1;
    object.aftersales = 1;
    object.qid = 0;
    object.facilityid = ficilityid;
    object.dealerid = dealerid;
    object.brandid = brand;
    object.year = year;
    object.factorid = keyid;

    trendingGraphFactorObject.name = name;

    setShowLoadinganimation(true);

    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/GetTrendingGraphData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setTrendingGraphFactorData(l_response);
          MakeLineGraphData(l_response);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  const [lineDataNumbers, setlineDataNumbers] = useState<[number, number][][]>(
    []
  );
  const [lineDataNumbersInput, setlineDataNumbersInput] = useState<[number, number][][]>(
    []
  );
  const [monthLabels, setmonthLabels] = useState<string[]>([]);
  interface MonthData {
    Score: number;
    NumericYear: number;
    NumericMonth: number;
    MonthName: string;
    Input : number;
  }

  const [graphLine, setGraphLine] = useState<[number, number][]>([]);

  
  const [graphLineInput, setGraphLineInput] = useState<[number, number][]>([]);


  function MakeLineGraphData(p_trendingGraphFactorData: any) {
    console.log(p_trendingGraphFactorData);

    var j = lineDataNumbers.length;
    for (var k = 0; k < j; k++) lineDataNumbers.pop();
    var j = lineDataNumbersInput.length;
    for (var k = 0; k < j; k++) lineDataNumbersInput.pop();

    var j2 = monthLabels.length;
    for (var k = 0; k < j2; k++) monthLabels.pop();
    p_trendingGraphFactorData.map((lineData: []) => {
      setGraphLine([]);

      lineData.map((monthData: MonthData) => {
        var monthName = monthData.MonthName;
        var monthIndex = 0;
        var monthFound = false;

        monthLabels.map((name, index) => {
          if (name == monthName) {
            monthFound = true;
            monthIndex = index + 1;
          }
        });
        if (monthFound == false) {
          monthLabels.push(monthName);
          monthIndex = monthLabels.length;
        }

        graphLine.push([monthIndex, monthData.Score]);
        
        graphLineInput.push([monthIndex, monthData.Input]);
      });
      var l = graphLine.length;
      if (l > 0) {
        var newGraphLine = JSON.parse(JSON.stringify(graphLine));
        for (var k = 0; k < l; k++) graphLine.pop();
        lineDataNumbers.push(newGraphLine);
      }
      
      var l = graphLineInput.length;
      if (l > 0) {
        var newGraphLine = JSON.parse(JSON.stringify(graphLineInput));
        for (var k = 0; k < l; k++) graphLineInput.pop();

        lineDataNumbersInput.push(newGraphLine);
      }

    });
    if (lineDataNumbers.length > 0) setLineChartPopup(true);
  }
  ////  Sorting Starts    /////
  function SetSortingImage() {
    var StepText = "";

    if (factorKeysObject.Step == 2) {
      StepText = "";
      if (factorKeysObject.Typeofreportdata == 1) {
        (
          document.getElementById(
            "imgSortCurrentScore" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

        (
          document.getElementById(
            "imgSortPreviousScore" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      } else {
        (
          document.getElementById(
            "imgSortCurrentScore" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

        (
          document.getElementById(
            "imgSortYTDScore" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      }

      //  Now For Factor
      for (var k = 1; k <= sectionScorecardFactorKeysData[2].length; k++) {
        (
          document.getElementById(
            "imgSortFactor" + k + "Point" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      }
    } else {
      StepText = "stp1";
      if (factorKeysObject.Typeofreportdata == 1) {
        (
          document.getElementById(
            "imgSortCurrentScore" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

        (
          document.getElementById(
            "imgSortPreviousScore" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      } else {
        (
          document.getElementById(
            "imgSortCurrentScore" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

        (
          document.getElementById(
            "imgSortYTDScore" + StepText
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById(
          "imgSort" + filters[0] + StepText
        ) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState("Data has been exported to file successfully.!");
  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  function getSectionScorecardFactorKeysDataForExport() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = props.ScreenID;
    object.facilityid = selectedId.Facilities;
    object.dealerid = selectedId.Dealers;
    object.brandid = selectedId.Brand;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    object.toggledata = factorKeysObject.toggledata;
    object.step = factorKeysObject.Step;
    object.typeofreportdata = factorKeysObject.Typeofreportdata;
    object.toggledatarange = factorKeysObject.Toggledatarange;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetSectionScorecardFactorKeysDataForExport",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].DownloadData;
          if (l_response[0][0].Status === 1) {
            setPopUpFileURL(link);
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getSectionScorecardFactorKeysDataForExportPDF() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = props.ScreenID;
    object.facilityid = selectedId.Facilities;
    object.dealerid = selectedId.Dealers;
    object.brandid = selectedId.Brand;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    object.toggledata = factorKeysObject.toggledata;
    object.step = factorKeysObject.Step;
    object.typeofreportdata = factorKeysObject.Typeofreportdata;
    object.toggledatarange = factorKeysObject.Toggledatarange;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetSectionScorecardFactorKeysDataForExportPDF",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].DownloadData;
          if (l_response[0][0].Status === 1) {
            setPopUpFileURL(link);
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <>
      <div className="page--contents">
        {showLoadinganimation && <LoadingAnimation />}
        <DownloadPopup
          ShowPopup={showPopUp}
          FileLink={popUpFileURL}
          Message={popUpMessage}
          DownloadPopupCallBack={DownloadPopupCallBack}
        />
        <div className="page--breadcrumb">
          <a>Retailer Scorecard</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items">
              <ScorecardFilters
                ScreenID={props.ScreenID}
                ScorecardFiltersCallBack={ScorecardFiltersCallBack}
              />

              <TabFilter
                DataType={1}
                SelectedValue={factorKeysObject.Toggledatarange}
                DataList={toggledatarangeArray}
                TabFilterCallback={handleTabFilterCallback}
              />

              {factorKeysObject.Step === 1 && (
                <TabFilter
                  DataType={2}
                  SelectedValue={factorKeysObject.toggledata}
                  DataList={toggledataArray}
                  TabFilterCallback={handleTabFilterCallback}
                />
              )}
              <TabFilter
                DataType={3}
                SelectedValue={factorKeysObject.Typeofreportdata}
                DataList={typeofreportdataArray}
                TabFilterCallback={handleTabFilterCallback}
              />
            </div>
          </div>
          <div className="page--tabs">
            <a
              className={`${
                factorKeysObject.Step === 1 ? "tab active" : "tab"
              }`}
              onClick={(e) =>
                setFactorKeysObject((prevState: any) => ({
                  ...prevState,
                  Step: 1,
                }))
              }
            >
              Aftersales Scorecard
              <span className="chevron"></span>
            </a>
            <a
              className={`${
                factorKeysObject.Step === 2 ? "tab active" : "tab"
              }`}
              onClick={(e) =>
                setFactorKeysObject((prevState: any) => ({
                  ...prevState,
                  Step: 2,
                  toggledata: 1,
                }))
              }
            >
              Details
              <span className="chevron"></span>
            </a>
          </div>
          <div className="section-table">
            {sectionScorecardFactorKeysData[0] && (
              <div className="legends-buttons">
                <div className="single-legend">
                  <p>{sectionScorecardFactorKeysData[0][0].ScoreTop}</p>
                  <span className="legend-1"></span>
                </div>
                <div className="single-legend">
                  <p>{sectionScorecardFactorKeysData[0][0].ScoreMiddle} </p>
                  <span className="legend-2"></span>
                </div>
                <div className="single-legend">
                  <p>{sectionScorecardFactorKeysData[0][0].ScoreBottom}</p>
                  <span className="legend-3"></span>
                </div>
                <div className="single-legend">
                  <p>INACTIVE</p>
                  <span className="legend-4"></span>
                </div>
                <a
                  className="btn-primary"
                  title="Export"
                  onClick={() => getSectionScorecardFactorKeysDataForExport()}
                >
                  <img
                    src="images/export.png"
                    width="13px"
                    height="15px"
                    alt="export"
                  />
                </a>
                <a
                  className="btn-primary"
                  title="Download PDF"
                  onClick={() =>
                    getSectionScorecardFactorKeysDataForExportPDF()
                  }
                >
                  <img
                    src="images/download.svg"
                    width="13px"
                    height="15px"
                    alt="download"
                  />
                </a>
              </div>
            )}

            <div className="flex-details Afs-score">
              {sectionScorecardFactorKeysData[1] && (
                <ColumnFilterCheckboxList
                  DataType={1}
                  RefreshFilters={refreshFilters}
                  GridData={sectionScorecardFactorKeysData[1]}
                  ColumnName={selectedColumnName}
                  ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
                  GetFilteredLists={getFilteredLists}
                  ReturnAllFilterdLists={{}}
                  ClickPosition={clickPosition}
                  Orientation={"Center"}
                  ColumnOrientation={[
                    { Name: "DealerName", Orientation: "Right" },
                  ]}
                />
              )}
              <div className="table-scroll">
                <table className="part-head trend-table" id="tblData">
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>
                        <span
                          onClick={(e) => ShowColumnFilterList(e, "DealerName")}
                          data-function="ShowColumnFilterList"
                        >
                          Importer
                        </span>
                      </th>
                      <th>
                        <span
                          onClick={(e) => ShowColumnFilterList(e, "Market")}
                          data-function="ShowColumnFilterList"
                        >
                          Market
                        </span>
                      </th>
                      <th>
                        <span
                          onClick={(e) => ShowColumnFilterList(e, "Facility")}
                          data-function="ShowColumnFilterList"
                        >
                          Retailer
                        </span>
                      </th>
                      <th>
                        <span
                          onClick={(e) =>
                            ShowColumnFilterList(e, "FacilityType")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          RT
                        </span>
                      </th>

                      {factorKeysObject.Typeofreportdata === 1 ? (
                        <>
                          <th>
                            Current Total
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("CurrentScore")
                              }
                              title="Sort By Current Score"
                            >
                              {factorKeysObject.Step === 1 ? (
                                <span id="imgSortCurrentScorestp1"></span>
                              ) : (
                                <span id="imgSortCurrentScore"></span>
                              )}
                            </a>
                          </th>
                          <th>
                            Previous Total
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("PreviousScore")
                              }
                              title="Sort By Previous Score"
                            >
                              {factorKeysObject.Step === 1 ? (
                                <span id="imgSortPreviousScorestp1"></span>
                              ) : (
                                <span id="imgSortPreviousScore"></span>
                              )}
                            </a>
                          </th>
                        </>
                      ) : (
                        <>
                          <th>
                            YTD
                            <a
                              onClick={() => LoadWithSelectedSort("YTDScore")}
                              title="Sort By YTD Score"
                            >
                              {factorKeysObject.Step === 1 ? (
                                <span id="imgSortYTDScorestp1"></span>
                              ) : (
                                <span id="imgSortYTDScore"></span>
                              )}
                            </a>
                          </th>
                          <th>
                            Current Total
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("CurrentScore")
                              }
                              title="Sort By Current Score"
                            >
                              {factorKeysObject.Step === 1 ? (
                                <span id="imgSortCurrentScorestp1"></span>
                              ) : (
                                <span id="imgSortCurrentScore"></span>
                              )}
                            </a>
                          </th>
                        </>
                      )}

                      {factorKeysObject.Step === 2 &&
                        sectionScorecardFactorKeysData[2] &&
                        sectionScorecardFactorKeysData[2].map(
                          (item: any, index: any) => (
                            <React.Fragment key={"ThMain" + index}>
                              {item.PFIRSTypeOfKeyID === 3 &&
                                selectedId.Brand > 0 && (
                                  <>
                                    <th>{item.Source1Name}</th>
                                    <th>{item.Source2Name}</th>
                                  </>
                                )}
                              <th
                                colSpan={selectedId.Brand > 0 ? 2 : 1}
                                title={item.InfoIconText}
                              >
                                {item.Name}
                              </th>
                            </React.Fragment>
                          )
                        )}
                    </tr>
                    {factorKeysObject.Step === 2 && (
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>

                        {sectionScorecardFactorKeysData[2] &&
                          sectionScorecardFactorKeysData[2].map(
                            (item: any, indexKpi: any) => (
                              <React.Fragment key={"Th" + indexKpi}>
                                {item.PFIRSTypeOfKeyID === 3 &&
                                  selectedId.Brand > 0 && (
                                    <>
                                      <th>{item.Source1Heading}</th>
                                      <th>{item.Source2Heading}</th>
                                    </>
                                  )}
                                {selectedId.Brand > 0 && (
                                  <th>
                                    {item.PFIRSTypeOfKeyID === 3
                                      ? "Value"
                                      : "Input"}
                                  </th>
                                )}
                                <th>
                                  Score
                                  <a
                                    onClick={() =>
                                      LoadWithSelectedSort(
                                        "Factor" + (indexKpi + 1) + "Point"
                                      )
                                    }
                                    title={"Sort By " + item.Name}
                                  >
                                    <span
                                      id={
                                        "imgSortFactor" +
                                        (indexKpi + 1) +
                                        "Point"
                                      }
                                    ></span>
                                  </a>
                                </th>
                              </React.Fragment>
                            )
                          )}
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {thisGridListData &&
                      thisGridListData.map((item: any, index: any) => (
                        <React.Fragment key={"Main" + index}>
                          {!item.IsExcluded && factorKeysObject.Step === 1 && (
                            <tr>
                              <td className={"ScoreCategory" + item.ScoreType}>
                                {item.Rank}
                              </td>
                              <td className={"ScoreCategory" + item.ScoreType}>
                                {item.DealerName}
                              </td>
                              <td className={"ScoreCategory" + item.ScoreType}>
                                {item.Market}
                              </td>
                              <td className={"ScoreCategory" + item.ScoreType}>
                                {item.Facility}
                              </td>
                              <td className={"ScoreCategory" + item.ScoreType}>
                                {item.FacilityType}
                              </td>
                              {factorKeysObject.Typeofreportdata === 1 ? (
                                <>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    <b> {item.CurrentScore}</b>
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.PreviousScore}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    className={"ScoreCategory" + item.ScoreType}
                                  >
                                    {item.YTDScore}
                                  </td>
                                  <td
                                    className={"ScoreCategory" + item.ScoreType}
                                  >
                                    {item.CurrentScore}
                                  </td>
                                </>
                              )}
                            </tr>
                          )}

                          {!item.IsExcluded &&
                            factorKeysObject.Step === 2 &&
                            (selectedId.Dealers == 0 ||
                              selectedId.Dealers == item.DealerID) && (
                              <tr>
                                <td
                                  className={"ScoreCategory" + item.ScoreType}
                                >
                                  {item.Rank}
                                </td>
                                <td
                                  className={"ScoreCategory" + item.ScoreType}
                                >
                                  {item.DealerName}
                                </td>
                                <td
                                  className={"ScoreCategory" + item.ScoreType}
                                >
                                  {item.Market}
                                </td>
                                <td
                                  className={"ScoreCategory" + item.ScoreType}
                                >
                                  {item.Facility}
                                </td>
                                <td
                                  className={"ScoreCategory" + item.ScoreType}
                                >
                                  {item.FacilityType}
                                </td>
                                {factorKeysObject.Typeofreportdata === 1 ? (
                                  <>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreType
                                      }
                                    >
                                      <b> {item.CurrentScore}</b>
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreType
                                      }
                                    >
                                      {item.PreviousScore}
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td
                                      className={
                                        "ScoreCategory" + item.ScoreType
                                      }
                                    >
                                      {item.YTDScore}
                                    </td>
                                    <td
                                      className={
                                        "ScoreCategory" + item.ScoreType
                                      }
                                    >
                                      {item.CurrentScore}
                                    </td>
                                  </>
                                )}

                                {factorKeysObject.Step === 2 &&
                                  sectionScorecardFactorKeysData[2] &&
                                  sectionScorecardFactorKeysData[2].map(
                                    (itemKpi: any, indexKpi: number) => (
                                      <React.Fragment key={"TD" + indexKpi}>
                                        {itemKpi.PFIRSTypeOfKeyID === 3 &&
                                          selectedId.Brand > 0 && (
                                            <>
                                              <td>
                                                {
                                                  item[
                                                    "Factor" +
                                                      (indexKpi + 1) +
                                                      "Value1Val"
                                                  ]
                                                }
                                              </td>
                                              <td>
                                                {
                                                  item[
                                                    "Factor" +
                                                      (indexKpi + 1) +
                                                      "Value2Val"
                                                  ]
                                                }
                                              </td>
                                            </>
                                          )}
                                        {selectedId.Brand > 0 && (
                                          <td
                                            onClick={() =>
                                              bindTrendingGraphFactor(
                                                item.DealerID,
                                                item.FacilityID,
                                                item.DealerName +
                                                  " [" +
                                                  item.Facility +
                                                  "] > " +
                                                  itemKpi.Name,
                                                selectedId.Years,
                                                selectedId.Brand,
                                                itemKpi.PFIRSFactorKeyID,
                                                itemKpi.PFIRSTypeOfKeyID,
                                                1,
                                                0,
                                                props.ScreenID
                                              )
                                            }
                                          >
                                            {
                                              item[
                                                "Factor" +
                                                  (indexKpi + 1) +
                                                  "ValueTextVal"
                                              ]
                                            }
                                          </td>
                                        )}
                                        <td
                                          onClick={() =>
                                            bindTrendingGraphFactor(
                                              item.DealerID,
                                              item.FacilityID,
                                              item.DealerName +
                                                " [" +
                                                item.Facility +
                                                "] > " +
                                                itemKpi.Name,
                                              selectedId.Years,
                                              selectedId.Brand,
                                              itemKpi.PFIRSFactorKeyID,
                                              itemKpi.PFIRSTypeOfKeyID,
                                              1,
                                              0,
                                              props.ScreenID
                                            )
                                          }
                                          className={
                                            "ScoreCategory" +
                                            item[
                                              "Factor" +
                                                (indexKpi + 1) +
                                                "Class"
                                            ]
                                          }
                                        >
                                          {
                                            item[
                                              "Factor" +
                                                (indexKpi + 1) +
                                                "Point"
                                            ]
                                          }
                                        </td>
                                      </React.Fragment>
                                    )
                                  )}
                              </tr>
                            )}
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {lineChartPopup && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Trending: {trendingGraphFactorObject.name}</h3>
                <a
                  className="close-help"
                  onClick={() => setLineChartPopup(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="popup-message">
              {props.ScreenID != 5 &&

<div className="toggle-switch">
 Points: <input type="checkbox"
    name="Input" id="ChkInput" checked={checkedPoints}
    onChange={handleChange} />Input

</div>
}
{checkedPoints ? (<> <LineChart data={lineDataNumbers} labelsProps={monthLabels} /></>) : (<><LineChart data={lineDataNumbersInput} labelsProps={monthLabels} /></>)}

              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NSAScorecard;
